import React from 'react'

export default class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, message: '' }
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error?.message || 'Something went wrong') }
  }
  componentDidCatch(error, info) {
    console.error('[RootErrorBoundary] error:', error, info)
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-6">
          <div className="max-w-md w-full text-center">
            <div className="mx-auto mb-4 text-5xl">⚠️</div>
            <h1 className="text-2xl font-semibold text-gray-800 mb-2">We hit a snag</h1>
            <p className="text-sm text-gray-600 mb-4">Please refresh the page. If the problem persists, contact support.</p>
            <details className="text-xs text-gray-500 whitespace-pre-wrap break-words bg-white rounded-lg border p-3">
              {this.state.message}
            </details>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}


